// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".link {\n  padding: 0 4px;\n  color: #000000;\n}\n", "",{"version":3,"sources":["webpack://./src/components/Home/ExternalLink/styles.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,cAAc;AAChB","sourcesContent":[".link {\n  padding: 0 4px;\n  color: #000000;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
